<p-dialog header="Request Audit Report"
          [(visible)]="showModal"
          (onHide)="closeModal()"
          [modal]="true"
          [resizable]="false"
          [contentStyle]="{ overflow: 'visible'}"
          [style]="{ width: '47rem' }">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-sm-6 mb-2 ps-2">
                <label for="reportName" class="form-label mb-0">Report Name<span class="text-danger"> * </span></label>
                <input type="text" class="form-control mt-0" id="reportName"
                       formControlName="reportName" data-identifier="uid-audit-reports-report-name" required
                       [ngClass]="{'is-invalid': form.controls['reportName'].invalid && (form.controls['reportName'].dirty || !form.controls['reportName'].untouched)}">
                <div *ngIf="form.controls['reportName']?.invalid && (form.controls['reportName']?.dirty || !form.controls['reportName'].untouched)">
                    <div *ngIf="form.controls['reportName']?.hasError('required')" class="text-danger">
                        Report Name is required.
                    </div>
                    <div *ngIf="form.controls['reportName']?.hasError('maxlength')" class="text-danger">
                        Report Name can not be longer than 255 characters.
                    </div>
                    <div *ngIf="form.controls['reportName']?.hasError('pattern')" class="text-danger">
                        {{ form.controls['reportName'].value.includes(' ') ? 'Report name must not include spaces.' : 'Report Name is not valid.' }}
                    </div>
                    <div *ngIf="form.controls['reportName']?.hasError('existingValue')" class="text-danger">
                        Report Name must be unique.
                    </div>
                </div>
            </div>

            <div class="col-sm-3 mb-2 ps-0">
                <label for="fromDate" class="form-label mb-0">From Date<span class="text-danger"> * </span></label>
                <lib-mm-datepicker
                    [placeholder]="'mm/dd/yyyy'"
                    [required]="true"
                    [minDate]="dateMin"
                    [maxDate]="dateMax"
                    [isInvalid]="form.controls['fromDate'].invalid && (form.controls['fromDate'].dirty || !form.controls['fromDate'].untouched)"
                    id="fromDate"
                    data-identifier="uid-audit-reports-from-date"
                    formControlName="fromDate">
                </lib-mm-datepicker>
                <div *ngIf="form.controls['fromDate'].invalid && (form.controls['fromDate'].dirty || !form.controls['fromDate'].untouched)">
                    <div *ngIf="form.controls['fromDate']?.hasError('required')" class="text-danger">
                        From Date is required.
                    </div>
                    <div *ngIf="form.controls['fromDate']?.hasError('badDate')" class="text-danger">
                        From Date is not a valid date.
                    </div>
                    <div *ngIf="form.controls['fromDate']?.hasError('beforeMinDate')" class="text-danger">
                        From Date cannot be
                        before {{ form.controls['fromDate'].errors?.['beforeMinDate']?.minDate }}
                    </div>
                    <div *ngIf="form.controls['fromDate']?.hasError('afterMaxDate')" class="text-danger">
                        From Date cannot be
                        after {{ form.controls['fromDate'].errors?.['afterMaxDate']?.maxDate }}
                    </div>
                </div>
            </div>

            <div class="col-sm-3 mb-2 ps-0">
                <label for="toDate" class="form-label mb-0">To Date<span class="text-danger"> * </span></label>
                <lib-mm-datepicker
                    [placeholder]="'mm/dd/yyyy'"
                    [required]="true"
                    [minDate]="dateMin"
                    [maxDate]="dateMax"
                    [isInvalid]="form.controls['toDate'].invalid && (form.controls['toDate'].dirty || !form.controls['toDate'].untouched)"
                    id="toDate"
                    data-identifier="uid-audit-reports-to-date"
                    formControlName="toDate">
                </lib-mm-datepicker>
                <div *ngIf="form.controls['toDate'].invalid && (form.controls['toDate'].dirty || !form.controls['toDate'].untouched)">
                    <div *ngIf="form.controls['toDate']?.hasError('required')" class="text-danger">
                        To Date is required.
                    </div>
                    <div *ngIf="form.controls['toDate']?.hasError('badDate')" class="text-danger">
                        To Date is not a valid date.
                    </div>
                    <div *ngIf="form.controls['toDate']?.hasError('beforeMinDate')" class="text-danger">
                        To Date cannot be
                        before {{ form.controls['toDate'].errors?.['beforeMinDate']?.minDate }}
                    </div>
                    <div *ngIf="form.controls['toDate']?.hasError('afterMaxDate')" class="text-danger">
                        To Date cannot be
                        after {{ form.controls['toDate'].errors?.['afterMaxDate']?.maxDate }}
                    </div>
                    <div *ngIf="form.controls['toDate']?.hasError('dateBeforeOtherDate')" class="text-danger">
                        To Date cannot be before From Date.
                    </div>
                    <div *ngIf="form.controls['toDate']?.hasError('datesNotInPeriod')" class="text-danger">
                        The maximum date range is {{ rangeDatesPeriod}} days.
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!isOrgAdminApp()">
            <div class="px-2">
                <label for="enterpriseSelect" class="pt-3">Organization</label>
                <lib-audit-report-enterprise-select
                    bindValue="id" data-identifier="uid-audit-reports-enterprises"
                    placeholder="Click to select..."
                    (click)="preventClickPropagation($event)"
                    (enterprisesSelectedEvent)="onEnterpriseSelected($event)">
                </lib-audit-report-enterprise-select>
            </div>
        </div>

        <div class="row" *ngIf="isOrgAdminApp()">
            <div class="px-2">
                <label for="userSelect" class="pt-3">User</label>
                <lib-audit-report-user-select
                   [enterpriseId]="enterpriseId"
                   bindValue="id" data-identifier="uid-audit-reports-users"
                   placeholder="Click to select..."
                   (click)="preventClickPropagation($event)"
                   (usersSelectedEvent)="onUserSelected($event)">
                </lib-audit-report-user-select>
            </div>
        </div>

        <div class="row">
            <div class="select-event px-2">
                <label for="eventCategorySelect" class="pt-3">Event Category</label>
                <ng-select #eventCategorySelect
                           [items]="eventCategories"
                           bindLabel="label"
                           bindValue="value"
                           [searchable]="false"
                           [clearable]="true"
                           (change)="onEventCategoryChange($event)"
                           data-identifier="uid-audit-reports-eventcategory"
                           placeholder="Select One"
                           formControlName="eventCategory">
                    <ng-template ng-label-tmp let-item="item">
                        <div class="col-3">{{ item.label }}</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div class="col-3">{{ item.label }}</div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="select-event px-1">
                <label for="eventNameSelect" class="pt-3">Event Name</label>
                <ng-select #eventNameSelect
                           [items]="eventNames"
                           bindLabel="label"
                           bindValue="value"
                           [searchable]="false"
                           [clearable]="true"
                           data-identifier="uid-audit-reports-eventname"
                           placeholder="Select One"
                           formControlName="eventName">
                    <ng-template ng-label-tmp let-item="item">
                        <div class="col-3">{{ item.label }}</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div class="col-3">{{ item.label }}</div>
                    </ng-template>
                </ng-select>
            </div>
        </div>
        <hr class="mt-4">
        <div class="d-flex justify-content-end">
            <button type="button" data-identifier="uid-audit-reports-cancel" class="btn btn-sm btn-outline-primary me-2"
                    (click)="closeModal()">Cancel
            </button>
            <button type="submit" data-identifier="uid-audit-reports-create-report" class="btn btn-sm btn-primary"
                    [disabled]="form.invalid" (click)="sendRequest()">Create Report</button>

        </div>
    </form>
</p-dialog>
